import {
  DisbursementDetailsDirect,
  DisbursementDetailsWallet,
  DisbursementRequestParams,
  DisbursementResponse,
} from '@/types/disbursements'

import { http } from './http'

export const getDisbursements = (params: DisbursementRequestParams) => {
  return http.get<DisbursementResponse>('payout/v2/worker/disbursements', {
    params,
  })
}

export const getDisbursementDetails = (detailsRef: string) =>
  http.get<DisbursementDetailsWallet | DisbursementDetailsDirect>(
    `payout${detailsRef}`
  )
